<template lang="html">
    <div class="login">
        <header class="header">
            <router-link :to="{ name: 'login', params: { locale: $i18n.locale } }">
              <img class="header-logo" src="../../src/assets/telecloud-logo.png">
            </router-link>
            <nav>
              <router-link :to="{ name: $route.name, params: { locale: l.code } }" v-for="l in locales" :key="l.code">
              {{ l.name }}
              </router-link>
            </nav>
        </header>
        <main class="main has-cover-background">
          <div class="container">
            <div class="row flex-center">
              <div class="card is-white col-mob-6 col-desk-4 col-auto">
                <div class="card-header">
                  <h1 class="card-title">{{ $t(title) }}</h1>
                </div>
                <div class="card-content">
                  <router-view/>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Toasters></Toasters>
    </div>
</template>

<script lang="js">
import Toasters from '@/components/Toasters.vue';

import { eventHubMixin } from '@/mixins/event';

import { getSupportedLocales } from "@/utils/i18n/supported-locales"

export default {
  name: 'PageLogin',
  mixins: [eventHubMixin],
  components: {
    Toasters
  },
  props: {
  },
  data() {
    return {
      title: '',
      locales: getSupportedLocales(),
    };
  },
  computed: {

  },
  beforeRouteUpdate(to, from, next) {
    this.init(to);
    next();
  },
  created() {
    this.init(this.$router.currentRoute);
  },
  mounted() {
    //
  },
  methods: {
    init(data) {
      this.title = data.meta.title;
    },
  },
};
</script>

<style lang="scss">
  //Currently no way to use assets in styles folder
  .main {
    background-image: url('../assets/cloud-crop-city.jpg')
  }
  .header {
    display: flex;
    justify-content: space-between;
    gap: 1.5rem; 

    nav {
      display: flex;
      justify-content: space-between;
      gap: 1rem; 
      padding: 0px 15px;
    }

    a {
      color: white;
      text-decoration: none;
    }

    a.router-link-exact-active {
      text-decoration: underline;
    }
  }
</style>
